import { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOnClickOutside(id: string, fn: () => void) {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onMouseDown(evt: any) {
      const shadowRoot = evt.target?.shadowRoot;
      const element = shadowRoot?.getElementById(id) || false;

      if (!element) fn();
      else return;
    }
    document.addEventListener('mousedown', onMouseDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [id]);
}

export default useOnClickOutside;
